import { createUseStyles } from 'react-jss';

export const styles = createUseStyles({
  panel: {
    zIndex: '999',
    margin: '0px',
    marginBottom: '20px',
    border: '1px solid #d0d0d0',
    padding: '5px',
    background: '#0c59cf',
    borderRadius: 4,
    boxShadow: '2px 2px 4px #0000004d',
    height: 44,
  },
  setting: {
    paddingBottom: '5px',
  },
  chartButton: {
    padding: '1px 6px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    borderRadius: 4,
  },
  chartImage: {
    width: '24px',
    height: '24px',
    filter: 'invert(100%)',
    marginTop: '2px',
    display: 'block',
  },
  chartEditButton: {
    background: '#fff',
    border: '2px solid #fff',
    color: '#0c59cf',
    fontSize: '.85em',
    fontWeight: 700,
    marginLeft: 10,
    padding: 5,
    borderRadius: 4,
    cursor: 'pointer',
  },
  selected: {
    background: '#fff',
    '& $chartImage': {
      filter:
        'brightness(0) saturate(100%) invert(24%) sepia(84%) saturate(2131%) hue-rotate(206deg) brightness(93%) contrast(96%)',
    },
  },
});
